module.exports = __webpack_public_path__ + "img/Group-5120.c5fb864c.svg";